import { ACTION_TYPES } from "./config";

export const actions = {
  /**
   * @param {boolean} status
   */
  setForAllMemberships: (status) => ({
    type: ACTION_TYPES.setForAllMemberships,
    payload: {
      status,
    },
  }),

  /**
   * @param {boolean} status
   */
  setForAllClinics: (status) => ({
    type: ACTION_TYPES.setForAllClinics,
    payload: {
      status,
    },
  }),

  /**
   * @param {{
   *    label: string;
   *    value: number;
   * }} membership
   */
  selectMembership: (membership) => ({
    type: ACTION_TYPES.selectMembership,
    payload: {
      membership,
    },
  }),

  /**
   * @param {Array<{
   *    label: string;
   *    value: string;
   * }>} memberships
   */
  setMemberships: (memberships = []) => ({
    type: ACTION_TYPES.setMemberships,
    payload: {
      memberships,
    },
  }),

  /**
   * @param {{
   *    [clinicId: string]: {
   *      perUnit: number;
   *      member: number;
   *      membershipId: number;
   *    }
   * }} preparedPrices - result of preparePrices from utilities
   *
   * @param {Array<{
   *    id: number;
   *    membership_tier_id: number;
   *    clinic_id: number;
   *    price_per_unit: number;
   *    price_per_unit_members: number;
   * }>} raw - raw response from API
   */
  setPrices: (
    preparedPrices = {},
    raw = [],
    adjustForAllClinicsFlag = false,
  ) => ({
    type: ACTION_TYPES.setPrices,
    payload: {
      preparedPrices,
      raw,
      adjustForAllClinicsFlag,
    },
  }),

  /**
   * @param {{
   *    type: string;
   *    value: number | string;
   *    clinicId: string | number;
   * }} param0
   */
  changePrice: ({ value, clinicId }) => ({
    type: ACTION_TYPES.changePrice,
    payload: {
      value,
      clinicId,
    },
  }),

  /**
   * @param {boolean} status
   */
  setInitialized: (status) => ({
    type: ACTION_TYPES.setInitialized,
    payload: {
      status,
    },
  }),

  /**
   * @param {Array<{
   *    id: number;
   *    name: string;
   * }>} clinics
   */
  setClinics: (clinics = []) => ({
    type: ACTION_TYPES.setClinics,
    payload: {
      clinics,
    },
  }),

  setOriginalToChangedPrices: () => ({
    type: ACTION_TYPES.setOriginalToChangedPrices,
  }),
};
